var React = require('react');

function XREALLogoWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.5 0.5H4.675L7.85 6.405H8.155L11.35 0.5H15.53L10.675 8.62L15.53 16.835H11.35L8.155 10.835H7.85L4.675 16.835H0.5L5.305 8.62L0.5 0.5ZM18 0.5H25.445C29.035 0.5 30.67 2.88 30.67 5.725C30.67 7.64 29.945 9.725 27.87 10.535L31.115 16.835H27.075L24.23 10.885H21.595V16.835H18V0.5ZM24.815 8.06C26.095 8.06 27.055 7.315 27.055 5.75C27.055 4.375 26.285 3.465 24.745 3.465H21.595V8.06H24.815ZM44.935 0.5H33.935V16.835H44.97V13.87H37.55V9.905H43.78V7.08H37.55V3.465H44.935V0.5ZM57 0.5L62.58 16.835H58.61L57.4 12.775H51.97L50.755 16.835H46.79L52.39 0.5H57ZM56.56 9.95L54.795 4.025H54.605L52.835 9.95H56.56ZM68.5 0.5H64.875V16.835H74.545V13.87H68.5V0.5Z","fill":"white"}));
}

XREALLogoWhite.defaultProps = {"width":"75","height":"17","viewBox":"0 0 75 17","fill":"none"};

module.exports = XREALLogoWhite;

XREALLogoWhite.default = XREALLogoWhite;
